module.exports = __webpack_public_path__ + "upload.svg";